export enum Command {
    Up = 'up',
    Down = 'down',
    Left = 'left',
    Right = 'right',

    Put = 'put',
}
